import type {HistoryServiceV3} from '@feature-hub/history-service';
import type {LinkType} from '@smart/web-components';
import type {ProductSearchContext} from '../contexts';
import {getSearch} from './get-search';

export function formattedSearchParams(
  queryParams?: string,
): string | undefined {
  return queryParams ? `?${queryParams.replaceAll(`,`, `&`)}` : undefined;
}

export function createLinkProps(options: {
  destination: {
    __typename: string;
    queryParams: string;
    url: string;
    page: {_path: string};
    _path: string;
  };
  label?: '' | undefined;
  historyService: HistoryServiceV3;
  applyFilter?: ProductSearchContext['applyFilter'];
}): LinkType {
  const {destination, label = ``, historyService} = options;
  if (destination.__typename === `ExternalPageModel`) {
    return {
      rel: `noopener nofollow`,
      target: `_blank`,
      isExternal: true,
      href: destination.url,
      label,
    };
  }
  const {_path: pathOrUrl} =
    destination.__typename === `PageModel` ? destination : destination.page;
  const search =
    destination.__typename === `ParameterizedPageModel`
      ? formattedSearchParams(destination.queryParams)
      : ``;
  return {
    onClick: (event) => {
      event.preventDefault();
      const location = {pathname: pathOrUrl, search};
      if (pathOrUrl.includes(`/stock-search`) && options?.applyFilter) {
        const facets = <
          {facetId: string; optionId: string; selected: boolean}[]
        >(getSearch(search, `url`) ?? []).map((item) => {
          const [facetId, optionId] = item.split(`:`);
          return {
            facetId,
            optionId,
            selected: true,
          };
        });
        if (facets.length) {
          options.applyFilter({facets});
          window.scrollTo(0, 0);
        }
        return;
      }
      historyService.rootHistory.push(location);
    },
    href: `${pathOrUrl}${search ?? ``}`,
    label,
  };
}
